/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Denied_ToastInputs */



/**
* | output |
* | --- |
* | "Notifications are blocked. Enable them in your browser settings to get table assignments." |
*
* @param {Notifications_Denied_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const notifications_denied_toast = /** @type {((inputs?: Notifications_Denied_ToastInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Denied_ToastInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les notifications sont bloquées. Autorisez-les dans les paramètres de votre navigateur pour recevoir vos placements à une table.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Las notificaciones están bloqueadas. Actívelas en los ajustes de su navegador para recibir su asignación de mesa.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("As notificações estão bloqueadas. Ative-as nas configurações do seu navegador para receber os assentos da sua mesa.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Le notifiche sono bloccate. Attivale nelle impostazioni del browser per ricevere il tuo posto al tavolo.")
	return /** @type {LocalizedString} */ ("Notifications are blocked. Enable them in your browser settings to get table assignments.")
});